import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";

const PsychometricTest = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const iframeRef = useRef(null);

  const testUrl = "https://www.careerguide.com/assessment/integration/ideal-career-test.aspx?hide_head=1&utm_source=partner_assessment&utm_campaign=megamindonline&utm_medium=megamindonline";

  useEffect(() => {
    const iframe = iframeRef.current;
    
    // Timeout to handle cases where onLoad might not fire
    const loadTimeout = setTimeout(() => {
      if (isLoading) {
        setIsLoading(false);
        setError("Test taking too long to load. Please check your internet connection.");
      }
    }, 10000); // 10 seconds timeout

    // Check if iframe has already loaded
    const checkIframeLoad = () => {
      try {
        const iframeContent = iframe?.contentWindow?.document;
        if (iframeContent && iframeContent.body) {
          setIsLoading(false);
          clearTimeout(loadTimeout);
        }
      } catch (err) {
        // This can happen due to cross-origin restrictions
        console.log('Iframe content check failed', err);
      }
    };

    // Initial check
    checkIframeLoad();

    // Periodic checks
    const intervalId = setInterval(checkIframeLoad, 2000);

    return () => {
      clearTimeout(loadTimeout);
      clearInterval(intervalId);
    };
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setError("Failed to load the psychometric test. Please try again later.");
  };


  return (
    <div className="container mt-5">
      <div className="row align-items-center mb-3">
        <div className="col-md-6">
          <h2 className="fs-4 fw-bold">Psychometric Test</h2>
        </div>
        <div className="col-md-6 text-md-end">
          <Link 
            to="/student/dashboard" 
            className="go-to-dashLink text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none"
          >
            Go To Dashboard
          </Link>
        </div>
      </div>

      {isLoading && (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading Psychometric Test...</p>
        </div>
      )}

      <div 
        className="row" 
        style={{ 
          display: isLoading || error ? 'none' : 'block' 
        }}
      >
        <div className="col-12">
          <iframe 
            ref={iframeRef}
            src={testUrl}
            title="Psychometric Test" 
            className="w-100"
            style={{
              height: '78vh', 
              border: '1px solid #dee2e6', 
              scrollbarWidth: 'none',
              borderRadius: '0.25rem'
            }}
            sandbox="allow-scripts allow-same-origin allow-forms"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default PsychometricTest;